// @ vendors
const { APIPost } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
// @ actions
const signaturePatternActions = require('actions/signaturePattern');
// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { FIRST_STEP } = require('constants/index');

const validateStepHelper = (step, getState) => {
    const step1Value = getState().depositChangeAccount.getIn(['steps',FIRST_STEP,'newAsociatedAccountId']);
    const errorMsg = formatText('depositChangeAccount-errorNoSelectedAccount');
    const valObj = (step1Value) ? {
        type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_VALIDATE_STEP,
        payload: {
            step
        }
    } : {
        type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_HANDLE_ERROR,
        payload: {
            errorMsg
        }
    }
    return valObj;
};

const requestAsociatedAccountInProgress = () => (dispatch) => {
    dispatch({
        type: actionTypes.FETCH_DEPOSIT_ASOCIATED_ACCOUNT_REQUEST,
        payload: {
            isFetchingAsociatedAccount: true
        }
    })
};

const requestAsociatedAccountSuccess = (response) => (dispatch) => {
    dispatch({
        type: actionTypes.FETCH_DEPOSIT_ASOCIATED_ACCOUNT_SUCCESS,
        payload: {
            asociatedAccount:response
        }
    });
};

const requestAsociatedAccountFailure = (error) => (dispatch) => {
    dispatch({
        type: actionTypes.FETCH_DEPOSIT_ASOCIATED_ACCOUNT_FAILURE,
        payload: {
            error
        }
    })
};

const setVisibleStep = (step) => (dispatch) => {
    dispatch({
        type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    });
};

const validateStep = (step) => (dispatch, getState) => {
    dispatch(validateStepHelper(step, getState));
};

const setDepositId = (depositId) => dispatch => {
    dispatch({
        type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_SET_DEPOSIT_ID,
        payload: {
            depositId
        }
    });
};

const setAsociatedAccountIdValue = (newAsociatedAccountId, iban, codbban, controlDigit, country) => ({
    type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_SET_ASOCIATED_ACCOUNT_ID,
    payload: {
        newAsociatedAccountId,
        iban,
        codbban,
        controlDigit,
        country
    }
});

const setAsociatedAccountId = accountId => (dispatch, getState) => {
    const selectedAccount = getState().accounts.getIn(['byId',accountId]);
    const values = [
        accountId,
        selectedAccount.get('iban'),
        selectedAccount.getIn(['ibanComplex','codbban']),
        selectedAccount.getIn(['ibanComplex','digitodecontrol']),
        selectedAccount.getIn(['ibanComplex','pais'])
    ];

    dispatch(setAsociatedAccountIdValue(...values));
}

const resetWizard = () => (dispatch) => {
    dispatch({
        type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_RESET
    })
};

const requestAsociatedAccount = (deposit) => (dispatch, getState) => {
    const isAlreadyFetching = getState().depositChangeAccount.get('isFetchingAsociatedAccount');

    if (!isAlreadyFetching) {
        const requestData = {
            query: {
                contrato: {
                    numerodecontrato: deposit.get('contractNumber'),
                    producto: deposit.get('product')
                }
            }
        };

        dispatch(requestAsociatedAccountInProgress());

        return APIPost({
                dispatch,
                endpoint: 'depositRequestAsociatedAccount',
                url: apiURLBuilder.getURL('depositRequestAsociatedAccount'),
                params: requestData
            })
            .then( response => dispatch(requestAsociatedAccountSuccess(response)))
            .catch(response => dispatch(requestAsociatedAccountFailure(response)));
    }
};

const showCancelModal = (show) => ({
    type: actionTypes.DEPOSIT_CHANGE_ACCOUNT_SHOW_CANCEL_MODAL,
    payload: {
        show
    }
});

const requestDepositModifyAsociatedAccountSuccess = () => ({
    type: actionTypes.FETCH_DEPOSIT_MODIFY_ASOCIATED_ACCOUNT_SUCCESS
});

const changeDepositModifyAsociatedAccountFailure = (error) => ({
    type: actionTypes.FETCH_DEPOSIT_MODIFY_ASOCIATED_ACCOUNT_FAILURE,
    payload: {
        error
    }
});

const depositModifyAsociatedAccountConf = function( dispatch, getState, dataToken) {
    const {
        depositChangeAccount,
        globalPosition,
        accounts
    } = getState();

    const depositId = depositChangeAccount.get('depositId');
    const deposit = globalPosition.getIn(['savings','allSavings']).find(option => {
        return option.get('id') === depositId;
    });

    const selectedAccountId = depositChangeAccount.getIn(['steps', FIRST_STEP, 'newAsociatedAccountId']);
    const selectedAccount = accounts.getIn(['byId', selectedAccountId]);
    const requestData = {
        query: {
            contratoActual: {
                numerodecontrato: deposit.get('contractNumber'),
                producto: deposit.get('product')
            },
            contratoNuevoAsoc: {
                codbban: selectedAccount.getIn(['ibanComplex','codbban']),
                digitodecontrol: selectedAccount.getIn(['ibanComplex','digitodecontrol']),
                pais: selectedAccount.getIn(['ibanComplex','pais'])
            },
            dataToken: dataToken
        }
    };

    return APIPost({
            dispatch,
            endpoint: 'depositModifyAsociatedAccount',
            url: apiURLBuilder.getURL('depositModifyAsociatedAccount'),
            params: requestData
        })
        .then( response => dispatch(requestDepositModifyAsociatedAccountSuccess(response)))
        .catch(response => dispatch(changeDepositModifyAsociatedAccountFailure(response)));
};

const requestSignaturePatternValidation = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        depositModifyAsociatedAccountConf(dispatch, getState, dataToken);
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const handleFinish = () => dispatch => {
    dispatch(requestSignaturePatternValidation());
};

module.exports = {
    setDepositId,
    setVisibleStep,
    setAsociatedAccountId,
    validateStep,
    resetWizard,
    requestAsociatedAccount,
    showCancelModal,
    handleFinish,
}
